// react
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Modern Elegant Category Vector Icons
 * Styled with stroke: currentColor, allowing seamless CSS transitions
 * between Hokky Blue (#0064d2) and Header Golden Yellow (#FFBA08).
 */

// 1. Alat Pertukangan (Tools)
export function ToolsIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Wrench */}
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
            <path d="M4 20l3.5-3.5" />
            {/* Hammer / Screwdriver Cross Accent */}
            <line x1="15" y1="9" x2="19" y2="5" />
            <line x1="8" y1="16" x2="10" y2="14" />
        </svg>
    );
}

// 2. Bahan Bangunan (Building Materials)
export function BuildingIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Wheelbarrow with Bricks */}
            <circle cx="18" cy="17" r="2.2" />
            <path d="M3.5 9h12.5l-2.2 6.5H7.2L3.5 9z" />
            <path d="M2 8.5L3.5 9" />
            <path d="M8 15.5v3.2m0 0h2" />
            <path d="M13.5 15.5l2.5 1.5" />
            {/* Stacked Bricks inside */}
            <rect x="6.5" y="5.5" width="7" height="3.5" rx="0.6" />
            <rect x="8" y="2.2" width="5.5" height="3.3" rx="0.6" />
        </svg>
    );
}

// 3. Cat (Paint)
export function PaintIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Paint Bucket with Drip */}
            <path d="M5.5 8.5h13l-1.3 10a2 2 0 0 1-2 1.7H8.8a2 2 0 0 1-2-1.7L5.5 8.5z" />
            <rect x="4.5" y="6.5" width="15" height="2" rx="1" />
            <path d="M7 6.5a5 5 0 0 1 10 0" />
            <path d="M6.8 11.5c2 0 3 1.5 5 1.5s3-1.5 5-1.5" />
            {/* Dripping Droplet */}
            <path d="M19.2 13.5c0 1.5-.9 2.5-1.7 2.5s-1.7-1-1.7-2.5c0-1 1.7-3 1.7-3s1.7 2 1.7 3z" />
        </svg>
    );
}

// 4. Dapur (Kitchen)
export function KitchenIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Kitchen Sink Basin & Faucet */}
            <rect x="3" y="8.5" width="18" height="12.5" rx="2" />
            <rect x="5" y="11" width="6.5" height="8" rx="1" />
            <circle cx="8.2" cy="15" r="0.8" />
            {/* Drainer Ribs */}
            <line x1="14" y1="11.5" x2="18.5" y2="11.5" />
            <line x1="14" y1="14" x2="18.5" y2="14" />
            <line x1="14" y1="16.5" x2="18.5" y2="16.5" />
            <line x1="14" y1="19" x2="18.5" y2="19" />
            {/* Gooseneck Faucet */}
            <path d="M8.2 8.5V5a2.5 2.5 0 0 1 5 0v1.5" />
            <line x1="7" y1="6.5" x2="9.5" y2="6.5" />
        </svg>
    );
}

// 5. Hardware
export function HardwareIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Modern Door Handle with Backplate */}
            <rect x="13" y="3" width="7" height="18" rx="3.5" />
            {/* Lever Handle */}
            <path d="M16.5 7.5H6a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h10.5" />
            {/* Screws */}
            <circle cx="16.5" cy="5.2" r="0.7" />
            <circle cx="16.5" cy="18.8" r="0.7" />
            {/* Keyhole */}
            <circle cx="16.5" cy="13.2" r="1.1" />
            <path d="M15.8 14.1l-.4 2.2h2.2l-.4-2.2" />
        </svg>
    );
}

// 6. Hobi (Hobby / Craft / Garden)
export function HobbyIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Heart with Craft Cross / Spark */}
            <path d="M12 21l-1.4-1.3C5.4 15.1 2 12 2 8.3A5.3 5.3 0 0 1 7.3 3c1.7 0 3.4.8 4.7 2.1C13.3 3.8 15 3 16.7 3A5.3 5.3 0 0 1 22 8.3c0 3.7-3.4 6.8-8.6 11.4L12 21z" />
            <circle cx="16" cy="14" r="3.6" />
            <line x1="16" y1="12" x2="16" y2="16" />
            <line x1="14" y1="14" x2="18" y2="14" />
        </svg>
    );
}

// 7. Kamar Mandi (Bathroom)
export function BathroomIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Overhead Shower & Droplets */}
            <path d="M3 4h8a4 4 0 0 1 4 4v2" />
            <path d="M11 10h8l1.5 3H9.5L11 10z" />
            {/* Water Spray Rays */}
            <line x1="10.8" y1="15.5" x2="9.8" y2="18.5" />
            <line x1="13.5" y1="15.5" x2="13" y2="19.5" />
            <line x1="16.5" y1="15.5" x2="17" y2="19.5" />
            <line x1="19.2" y1="15.5" x2="20.2" y2="18.5" />
            <circle cx="13" cy="21.5" r="0.65" />
            <circle cx="17" cy="21.5" r="0.65" />
        </svg>
    );
}

// 8. Lantai & Dinding (Flooring & Wall)
export function FlooringIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* 4 Ceramic Floor Tiles */}
            <rect x="3.5" y="4" width="7.5" height="6.5" rx="1.5" />
            <rect x="13" y="4" width="7.5" height="6.5" rx="1.5" />
            <rect x="3.5" y="13.5" width="7.5" height="6.5" rx="1.5" />
            <rect x="13" y="13.5" width="7.5" height="6.5" rx="1.5" />
            {/* Tile Reflections */}
            <line x1="6" y1="6" x2="8.5" y2="8.5" />
            <line x1="15.5" y1="15.5" x2="18" y2="18" />
        </svg>
    );
}

// 9. Listrik & Pencahayaan (Electrical & Lighting)
export function ElectricalIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Light Bulb with Radiant Rays */}
            <path d="M9 17h6" />
            <path d="M10 20h4" />
            <path d="M12 2a6.5 6.5 0 0 0-4.5 11.2c.8.8 1.5 2 1.5 3.3h6c0-1.3.7-2.5 1.5-3.3A6.5 6.5 0 0 0 12 2z" />
            <path d="M10.5 11l1.5-3 1.5 3" />
            {/* Glow Rays */}
            <line x1="12" y1="-0.5" x2="12" y2="1" />
            <line x1="4.8" y1="4.8" x2="3.4" y2="3.4" />
            <line x1="19.2" y1="4.8" x2="20.6" y2="3.4" />
            <line x1="1.5" y1="10" x2="3" y2="10" />
            <line x1="21" y1="10" x2="22.5" y2="10" />
        </svg>
    );
}

// 10. Peralatan Rumah Tangga (Household)
export function HouseholdIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Clothes Hanger with Folded Towel */}
            <path d="M12 3a2.5 2.5 0 0 1 2.5 2.5c0 1.2-1 2-2.5 2.5" />
            <path d="M12 8L2.5 14.5a1 1 0 0 0 .5 1.7h18a1 1 0 0 0 .5-1.7L12 8z" />
            <rect x="7" y="16.2" width="10" height="5.8" rx="1.5" />
            <line x1="7" y1="19" x2="17" y2="19" strokeDasharray="1.5 1.5" />
        </svg>
    );
}

// 11. Pintu & Jendela (Door & Window)
export function DoorWindowIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <line x1="12" y1="3" x2="12" y2="21" />
            <rect x="5.5" y="6" width="4" height="6" rx="1" />
            <rect x="14.5" y="6" width="4" height="6" rx="1" />
            <line x1="10" y1="14" x2="10" y2="16" />
            <line x1="14" y1="14" x2="14" y2="16" />
        </svg>
    );
}

// 12. Semua Kategori (All Categories)
export function AllCategoryIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="3" y="3" width="7.5" height="7.5" rx="2" />
            <rect x="13.5" y="3" width="7.5" height="7.5" rx="2" />
            <rect x="3" y="13.5" width="7.5" height="7.5" rx="2" />
            <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2" />
        </svg>
    );
}

// 13. Default Tag / Promo Badge (Exact Concept from User Reference Image 2!)
export function DefaultTagIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Slanted Tag with Percent Sign from Image 2 */}
            <path d="M14.5 3.5l6 6a2 2 0 0 1 0 2.8l-8 8a2 2 0 0 1-2.8 0l-6-6a2 2 0 0 1-.6-1.4v-6a2 2 0 0 1 2-2h6a2 2 0 0 1 1.4.6z" />
            <circle cx="7.5" cy="7.5" r="1.5" />
            <line x1="11" y1="15" x2="15" y2="11" />
            <circle cx="11.5" cy="11.5" r="0.8" />
            <circle cx="14.5" cy="14.5" r="0.8" />
        </svg>
    );
}

// 14. Selengkapnya / More Categories Icon
export function MoreCategoryIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="3" y="3" width="7" height="7" rx="2" />
            <rect x="14" y="3" width="7" height="7" rx="2" />
            <rect x="3" y="14" width="7" height="7" rx="2" />
            <path d="M14 17.5h7m-3.5-3.5l3.5 3.5-3.5 3.5" />
        </svg>
    );
}

// 15. Tutup / Collapse Categories Icon
export function CollapseCategoryIcon({ size = 34, className = '' }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.85"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="9" />
            <polyline points="8 13.5 12 9.5 16 13.5" />
            <line x1="8" y1="16.5" x2="16" y2="16.5" />
        </svg>
    );
}

/**
 * Intelligent Category Icon Resolver
 * Matches category name to appropriate elegant vector icon.
 */
export function getCategoryIcon(name, size = 34, className = '') {
    const n = (name || '').toLowerCase().trim();

    if (n.includes('tutup') || n.includes('close') || n.includes('sembunyikan') || n.includes('collapse')) {
        return <CollapseCategoryIcon size={size} className={className} />;
    }
    if (n.includes('selengkapnya') || n.includes('more') || n.includes('lainnya') || n.includes('show all') || n.includes('lihat semua')) {
        return <MoreCategoryIcon size={size} className={className} />;
    }
    if (n.includes('tukang') || n.includes('tool') || n.includes('alat')) {
        return <ToolsIcon size={size} className={className} />;
    }
    if (n.includes('bahan') || n.includes('bangunan') || n.includes('semen') || n.includes('pasir') || n.includes('batu')) {
        return <BuildingIcon size={size} className={className} />;
    }
    if (n.includes('cat') || n.includes('paint') || n.includes('kuas') || n.includes('thinner')) {
        return <PaintIcon size={size} className={className} />;
    }
    if (n.includes('dapur') || n.includes('kitchen') || n.includes('wastafel') || n.includes('sink')) {
        return <KitchenIcon size={size} className={className} />;
    }
    if (n.includes('hardware') || n.includes('kunci') || n.includes('gagang') || n.includes('engsel') || n.includes('baut')) {
        return <HardwareIcon size={size} className={className} />;
    }
    if (n.includes('hobi') || n.includes('hobby') || n.includes('taman') || n.includes('craft')) {
        return <HobbyIcon size={size} className={className} />;
    }
    if (n.includes('mandi') || n.includes('shower') || n.includes('sanitary') || n.includes('toilet') || n.includes('closet')) {
        return <BathroomIcon size={size} className={className} />;
    }
    if (n.includes('lantai') || n.includes('dinding') || n.includes('keramik') || n.includes('granit') || n.includes('vinyl') || n.includes('flooring')) {
        return <FlooringIcon size={size} className={className} />;
    }
    if (n.includes('listrik') || n.includes('cahaya') || n.includes('lampu') || n.includes('elektronik') || n.includes('lighting')) {
        return <ElectricalIcon size={size} className={className} />;
    }
    if (n.includes('rumah tangga') || n.includes('peralatan') || n.includes('tangga') || n.includes('home')) {
        return <HouseholdIcon size={size} className={className} />;
    }
    if (n.includes('pintu') || n.includes('jendela') || n.includes('door') || n.includes('window')) {
        return <DoorWindowIcon size={size} className={className} />;
    }
    if (n.includes('all') || n.includes('semua')) {
        return <AllCategoryIcon size={size} className={className} />;
    }

    return <DefaultTagIcon size={size} className={className} />;
}

export default function CategoryIcon({ name, size = 34, className = '' }) {
    return getCategoryIcon(name, size, className);
}

CategoryIcon.propTypes = {
    name: PropTypes.string,
    size: PropTypes.number,
    className: PropTypes.string,
};
